import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="utils--expand-details"
export default class extends Controller {
  static targets = ['expandOnShow', 'collapseOnShow']

  connect() {
    this.expandOnShowTargets.forEach(el => el.classList.add('collapse'))
    this.collapseOnShowTargets.forEach(el => el.classList.remove('collapse'))
  }

  toggle() {
    this.expandOnShowTargets.forEach(el => el.classList.toggle('show'))
    this.collapseOnShowTargets.forEach(el => el.classList.toggle('collapse'))
  }

  collapse() {
    this.expandOnShowTargets.forEach(el => {
      el.classList.remove('show')
      el.classList.add('collapse')
    })
    this.collapseOnShowTargets.forEach(el => el.classList.remove('collapse'))
  }
}
